import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

export interface IHeaderTitleProps {
    titleText: GenericLazyString;
    titleClassName?: string;
}

const HeaderTitle = ({ titleText, titleClassName = '' }: IHeaderTitleProps) => {
    let headerClasses = 'eds-text-hl';

    if (titleClassName) {
        headerClasses = `${headerClasses} ${titleClassName}`;
    }

    return (
        <h1 className={headerClasses} data-testid="page-header-title">
            {titleText}
        </h1>
    );
};

export default HeaderTitle;
